export default __webpack_public_path__ + "b934755a6b9b03823636d7535365ee51.jpg";